<h1 class="underline" mat-dialog-title>{{this.serviceProviderName}}</h1>

<h2 class="underline">{{this.serviceProviderBusinessName}}</h2>
@if (updatingInvoice) {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="Service Plan">
    <th mat-header-cell *matHeaderCellDef>Service Plan Description</th>
    <td mat-cell *matCellDef="let element">{{ element.contractServicePlan.servicePlanModel.description }}</td>
  </ng-container>

  <ng-container matColumnDef="Customer">
    <th mat-header-cell *matHeaderCellDef>Customer</th>
    <td mat-cell *matCellDef="let element">
      {{ element.contractServicePlan.contractModel.applicationModel.userModel.firstName}} {{element.contractServicePlan.contractModel.applicationModel.userModel.lastName  }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Service Type">
    <th mat-header-cell *matHeaderCellDef>Service Type</th>
    <td mat-cell *matCellDef="let element">{{ element.contractServicePlan.servicePlanModel.serviceTypeModel.name }}</td>
  </ng-container>

  <ng-container matColumnDef="Bill">
    <th mat-header-cell *matHeaderCellDef>Bill</th>
    <td mat-cell *matCellDef="let element">${{ element.billableAmount.toFixed(2) }}</td>
  </ng-container>

  <ng-container matColumnDef="Paid">
    <th mat-header-cell *matHeaderCellDef>Paid</th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [checked]="element.paid" (change)="updateInvoicePaidStatus(element)"></mat-checkbox>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">Close</button>
</mat-dialog-actions>
